'use client';

import React from 'react';
import { Slide } from '@/shared/types';
import { GlobeIcon } from '@phosphor-icons/react';

// Interfaces and types
interface LocationPaneProps {
  slide: Slide;
}

// Component definition
const LocationPane: React.FC<LocationPaneProps> = ({ slide }) => {
  // Initialize state
  return (
    <div className='slide-boxes mini text-white'>
      <GlobeIcon weight="duotone" className='w-4 h-4' />
      <span>{slide.location?.name || slide.location?.address}</span>
    </div>
  );
}

export default LocationPane;